import { useState, useEffect } from 'react'
import { responsiveMap } from '../helpers/constants/responsive'

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
        size: ''
    })

    const toCssSize = width => {
        const size = Object.keys(responsiveMap)
            .filter(n => width <= n && responsiveMap[n])
            .map(n => responsiveMap[n])[0]

        return size
    }

    const calculateWindowSize = () => ({ width: window.innerWidth, height: window.innerHeight, size: toCssSize(window.innerWidth) })
    const handleResize = () => { setWindowSize(calculateWindowSize()) }

    useEffect(() => {
        window.addEventListener('resize', handleResize)

        handleResize()

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowSize
}

export default useWindowSize